import { __rest, __assign } from '../../_virtual/_tslib.js';
import React, { useState, useRef, useEffect } from 'react';
import Description from '../../Description/index.js';
import { StyledTextareaOuterWrapper, StyledTextareaInnerWrapper, StyledLabel, StyledTextarea, StyledDescriptionWrapper, LengthLimitCaption } from './style.js';

function Textarea(_a) {
    var style = _a.style, label = _a.label, value = _a.value, id = _a.id, onChange = _a.onChange, lengthLimit = _a.lengthLimit, showDescription = _a.showDescription, descriptionState = _a.descriptionState, descriptionMessages = _a.descriptionMessages, descriptionMessageKey = _a.descriptionMessageKey, validate = _a.validate, className = _a.className, height = _a.height, _b = _a.resize, resize = _b === void 0 ? 'none' : _b, props = __rest(_a, ["style", "label", "value", "id", "onChange", "lengthLimit", "showDescription", "descriptionState", "descriptionMessages", "descriptionMessageKey", "validate", "className", "height", "resize"]);
    var _c = useState(false), isFocused = _c[0], setIsFocused = _c[1];
    var textareaRef = useRef(null);
    var _d = useState('100%'), textareaWidth = _d[0], setTextareaWidth = _d[1];
    var _e = useState(1), zIndexOfLabel = _e[0], setZIndexOfLabel = _e[1];
    useEffect(function () {
        var textarea = textareaRef.current;
        var resizeObserver = new ResizeObserver(function (entries) {
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var entry = entries_1[_i];
                var clientHeight = textarea === null || textarea === void 0 ? void 0 : textarea.clientHeight;
                var scrollHeight = textarea === null || textarea === void 0 ? void 0 : textarea.scrollHeight;
                if (Number(scrollHeight) > Number(clientHeight)) {
                    setZIndexOfLabel(0);
                }
                else {
                    setZIndexOfLabel(1);
                }
                if (entry.borderBoxSize && entry.borderBoxSize.length > 0) {
                    setTextareaWidth(entry.borderBoxSize[0].inlineSize / 10 + "rem");
                }
            }
        });
        if (textarea !== null) {
            resizeObserver.observe(textarea);
            return function () {
                resizeObserver.disconnect();
            };
        }
    }, []);
    return (React.createElement(StyledTextareaOuterWrapper, { style: style, className: className },
        React.createElement(StyledTextareaInnerWrapper, { onFocus: function () {
                setIsFocused(true);
            }, onBlur: function (e) {
                if (!e.currentTarget.contains(e.relatedTarget)) {
                    setIsFocused(false);
                    if (validate) {
                        validate();
                    }
                }
            } },
            React.createElement(StyledLabel, __assign({}, props, { htmlFor: id, textareaValue: value, isFocused: isFocused, zIndex: zIndexOfLabel }), label),
            React.createElement(StyledTextarea, __assign({ value: value, onChange: function (e) {
                    var textarea = e.target;
                    var clientHeight = textarea.clientHeight;
                    var scrollHeight = textarea.scrollHeight;
                    if (scrollHeight > clientHeight) {
                        setZIndexOfLabel(0);
                    }
                    else {
                        setZIndexOfLabel(1);
                    }
                    if (Number(lengthLimit) > 0) {
                        e.target.value = e.target.value.slice(0, lengthLimit);
                    }
                    onChange(e);
                }, onScroll: function (e) {
                    var textarea = e.target;
                    var scrollTop = textarea.scrollTop;
                    if (scrollTop > 0) {
                        setZIndexOfLabel(0);
                    }
                    else {
                        setZIndexOfLabel(1);
                    }
                }, labelOfTextarea: label, id: id, isFocused: isFocused, height: height, ref: textareaRef, resize: resize }, props))),
        React.createElement(StyledDescriptionWrapper, { width: textareaWidth, reverseDirection: Boolean(lengthLimit) && !showDescription },
            showDescription &&
                descriptionState &&
                descriptionMessages &&
                typeof descriptionMessageKey === 'string' && (React.createElement(Description, { state: descriptionState, messages: descriptionMessages, messageKey: descriptionMessageKey })),
            showDescription && !isNaN(Number(lengthLimit)) && descriptionState && (React.createElement(LengthLimitCaption, { state: descriptionState },
                value.length,
                "/",
                lengthLimit)))));
}

export { Textarea as default };
